import { useState } from "react";
import { Card, CardBody, Stack, Dropdown, Modal, Button, Form, Row, Col } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";

import Api from "../../../api/Api";
import { getUserData } from "../../reuse/getUserRole";


function ArchiveMenuItem({ audit }) {
  const [show, setShow] = useState(false);
  const [password, setPassword] = useState("");
  const [fieldType, setFieldType] = useState(false);

  const handleClose = () => {
    setShow(false);
    setPassword("");
    setFieldType(false);
  };

  const handleArchive = async () => {
    if (!password) {
      alert("Введите пароль!");
      return;
    }
    try {
      await Api({
        method: "post",
        url: `/audits/@${audit.id}/archive`,
        headers: { password: password },
      });
      alert("Аудит архивирован");
      window.location.reload();
    } catch (error) {
      alert(`Ошибка при архивации аудита. \n ${error}`);
    }
  };

  return (
    <>
      <Dropdown.Item onClick={() => setShow(true)}>Архивировать</Dropdown.Item>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text_font">Архив</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Text className="text_font">
            Вы уверены, что хотите архивировать аудит "{audit.name}"?
          </Form.Text>
          <Form.Control
            type={fieldType ? "text" : "password"}
            placeholder="Для архивации аудита введите пароль пользователя..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Form.Check
            checked={fieldType}
            onChange={(e) => setFieldType(e.target.checked)}
            type="switch"
            label="Скрыть/показать пароль"
          />
          <Row className="mt-2">
            <Col>
              <Button variant="light" className="free-btn" onClick={handleClose}>
                Отмена
              </Button>
            </Col>
            <Col>
              <Button className="free-btn" onClick={handleArchive}>
                Да, подтвердить
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}


function DeleteMenuItem({ audit }) {
  const [show, setShow] = useState(false);
  const [password, setPassword] = useState("");
  const [fieldType, setFieldType] = useState(false);

  const handleClose = () => {
    setShow(false);
    setPassword("");
    setFieldType(false);
  };

  const handleDelete = async () => {
    if (!password) {
      alert("Введите пароль!");
      return;
    }
    try {
      await Api({
        method: "delete",
        url: `/audits/@${audit.id}`,
        headers: { password: password },
      });
      alert("Аудит удалён из системы");
      window.location.reload();
    } catch (error) {
      alert(`Ошибка при удалении аудита. \n ${error}`);
    }
  };

  return (
    <>
      <Dropdown.Item onClick={() => setShow(true)}>Удалить</Dropdown.Item>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text_font">Внимание</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Text className="text_font">
            Вы уверены, что хотите удалить аудит "{audit.name}" из системы? После
            удаления, его нельзя будет восстановить!
          </Form.Text>
          <Form.Control
            type={fieldType ? "text" : "password"}
            placeholder="Для подтверждения введите пароль пользователя..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Form.Check
            checked={fieldType}
            onChange={(e) => setFieldType(e.target.checked)}
            type="switch"
            label="Скрыть/показать пароль"
          />
          <Row className="mt-2">
            <Col>
              <Button variant="light" className="free-btn" onClick={handleClose}>
                Отмена
              </Button>
            </Col>
            <Col>
              <Button variant="danger" className="free-btn" onClick={handleDelete}>
                Да, удалить
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}


// >>> НАСТРОЙКА: подписи для типа аудита
const auditTypes = { common: "Обычный", "self-esteem": "Самоаудит" };

// >>> НАСТРОЙКА: цвет и подпись бейджа активности
const statusVariants = {
  true: { name: "Активный", color: "custom_badge_success" },
  false: { name: "Неактивный", color: "custom_badge_secondary" },
};


export default function CalendarAuditCard({ audit, accentColor }) {
  const role = getUserData();
  const isArchived = audit?.is_archived === true;
  const canManage = role === "Admin" || role === "Moderator";

  const formatDate = (value) => {
    if (!value) return "—";
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString("ru-RU");
  };

  // клик по телу карточки: архивный уходит на результаты, обычный — на прохождение
  const handleCardBodyClick = () => {
    if (isArchived) {
      if (audit?.results_access) {
        window.location.href = `/audit_result_page/${audit.id}`;
      } else {
        alert("У вас нет доступа к результатам аудита!");
      }
    } else if (audit?.is_active) {
      window.location.href = `/audit_page/${audit.id}`;
    } else {
      alert("Аудит не активирован. Доступ отсутствует");
    }
  };

  const handleViewResults = () => {
    if (audit?.results_access) {
      window.location.href = `/audit_result_page/${audit.id}`;
    } else {
      alert("У вас нет доступа к результатам аудита!");
    }
  };

  const handleSelectAudit = () => {
    window.location.href = `/audit_page/${audit.id}`;
  };

  const handleChangeAudit = () => {
    window.location.href = `/change_audit/${audit.id}`;
  };

  const handleChangeStatus = async () => {
    try {
      await Api({
        method: "post",
        url: `/audits/@${audit.id}/set_active/${!audit.is_active}`,
        headers: {},
      });
      window.location.reload();
    } catch (error) {
      alert(`Ошибка при изменении статуса аудита \n ${error}`);
    }
  };

  return (
    <Card
      className="mt-2 mb-1 audit_card_block calendar-audit-card"
      style={accentColor ? { borderLeft: `4px solid ${accentColor}` } : undefined}
    >
      <CardBody>
        <Stack direction="horizontal">
          <div className="text_font">
            {formatDate(audit?.start_datetime)} - {formatDate(audit?.end_datetime)}
          </div>
          <div className="ms-auto">
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="light border"
                id={`dropdown-${audit?.id}`}
                size="sm"
              >
                <BsThreeDotsVertical />
              </Dropdown.Toggle>

              <Dropdown.Menu
                popperConfig={{ strategy: "fixed" }}
                renderOnMount
              >
                {audit.is_active && !audit.is_archived && <Dropdown.Item onClick={handleSelectAudit}>Выбрать</Dropdown.Item>}
                {audit.results_access && <Dropdown.Item onClick={handleViewResults}>Посмотреть результаты</Dropdown.Item>}
                {audit.change_activity && <Dropdown.Item onClick={handleChangeStatus}>Изменить статус</Dropdown.Item>}
                {canManage && <>
                  {!audit.is_archived && <Dropdown.Item onClick={handleChangeAudit}>Редактировать</Dropdown.Item>}
                  {!audit.is_archived && <ArchiveMenuItem audit={audit} />}
                  <DeleteMenuItem audit={audit} />
                </>}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Stack>

        <div onClick={handleCardBodyClick} style={{ cursor: "pointer" }}>
          <div className="mt-2">
            <Stack direction="horizontal" gap={1}>
              {!isArchived && (
                <div className={statusVariants[audit?.is_active]?.color}>
                  {statusVariants[audit?.is_active]?.name}
                </div>
              )}
              <div className="custom_badge_secondary">
                {auditTypes[audit?.audit_type] || "—"}
              </div>
              {isArchived && (
                <div className="custom_badge_dark">Архивный</div>
              )}
            </Stack>
          </div>
          <div className="mt-1">
            <div className="text_font">Завод: {audit?.facility || "—"}</div>
            <div className="text_font audit_card_block_text">
              {audit?.name || "—"}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
